import React from 'react';
import { Spinner } from 'react-bootstrap';

const StatusCards = React.memo(({ notStarted, partial, final, completed, loading, hasSelectedCompanies }) => {
    return (
        <div className="dashboard-header">
            <div className="container" style={{ padding: "0" }}>
                <div className="row">
                    <span style={{ fontSize: 11, color: "#7F7F8A", fontWeight: 400, textAlign: "center", paddingBottom: 10 }}>
                        Based on kpi's of expanded companies
                    </span>
                    <div className="col-md-3 col-sm-12">
                        <div className="card row">
                            <div className="title-col col-md-12">
                                <div className="card-title">Not Started</div>
                                <div className="card-number">
                                    {hasSelectedCompanies ? (
                                        loading ? (
                                            <Spinner variant="info" animation="border" />
                                        ) : (
                                            `${notStarted}%`
                                        )
                                    ) : 0}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-3">
                        <div className="card row">
                            <div className="title-col col-md-12">
                                <p className="card-title">Partial Approval</p>
                                <p className="card-number">
                                    {hasSelectedCompanies ? (
                                        loading ? (
                                            <Spinner variant="info" animation="border" />
                                        ) : (
                                            `${partial}%`
                                        )
                                    ) : 0}
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-3">
                        <div className="card row">
                            <div className="title-col col-md-12">
                                <p className="card-title">Final Approval</p>
                                <p className="card-number">
                                    {hasSelectedCompanies ? (
                                        loading ? (
                                            <Spinner variant="info" animation="border" />
                                        ) : (
                                            `${final}%`
                                        )
                                    ) : 0}
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md-3">
                        <div className="card row">
                            <div className="title-col col-md-12">
                                <p className="card-title">Completed</p>
                                <p className="card-number">
                                    {hasSelectedCompanies ? (
                                        loading ? (
                                            <Spinner variant="info" animation="border" />
                                        ) : (
                                            `${completed}%`
                                        )
                                    ) : 0}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

StatusCards.displayName = 'StatusCards';

export default StatusCards;


